import { create } from "zustand";
import { apiService } from "../services/apiService";
import { getDecodedToken } from "../utils/helpers";

export const useUserStore = create((set) => ({
  user: null,

  setUser: (user) => set({ user }),

  clearUser: () => set({ user: null }),

  fetchUser: async () => {
    const decodedToken = getDecodedToken();

    if (!decodedToken) return;

    try {
      const userData = await apiService.get(
        `/BusinessAccount/${decodedToken.buid}`,
      );

      const profileUrl =
        userData.profileUrl && userData.profileUrl.includes("/?")
          ? `${userData.profileUrl}`
          : userData.profileUrl
            ? `${userData.profileUrl}?updated=${Date.now()}`
            : null;

      set({
        user: {
          ...userData,
          profileUrl,
        },
      });
    } catch (error) {
      console.error(error);
    }
  },
}));
